
import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import TermSection from './components/TermSection'

const Terms = () => {
  return (
    <div>
      <Navbar/>
      <TermSection/>
      
    </div>
  )
}

export default Terms
